import script from "./AppCartOverview.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppCartOverview.vue?vue&type=script&lang=ts&setup=true"

import "./AppCartOverview.vue?vue&type=style&index=0&id=a5ce97b4&lang=scss"

const __exports__ = script;

export default __exports__